import React, { useEffect } from 'react';
import { connect } from 'react-redux';

function DisconnectSessionTimer({
  onTimeOut,
  stream,
  timers,
  timerRef
}) {
  useEffect(() => {
    const timer = timerRef;
    if (timer && timers) {
      timer.current = setTimeout(() => {
        if (stream) {
          onTimeOut();
        }
      }, timers.diconnectTimer * 1000);
      return () => clearInterval(timer.current);
    }
    return () => {};
  }, [timers]);

  return <div />;
}

const mapStateToProps = ({ voipChat }) => ({ ...voipChat, ...voipChat.conversationOption });

export default connect(mapStateToProps, {})(DisconnectSessionTimer);
